function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.776 4.195l1.794-1.668L4 1l1.65 7.032 1.603-1.49c.087.075.18.158.282.253.886.827 2.325 2.464 2.001 4.14-.246 1.273-1.474 2.389-3.65 3.315-.2.086-.296.3-.22.493a.395.395 0 00.097.142c.105.098.26.14.412.1 1.065-.28 4.613-1.414 5.586-4.243.65-1.89-.03-4.093-1.985-6.547z",
  fill: "currentColor"
})));